/** Single source of truth for league naming shown in the UI. */
export const LEAGUE_NAME = 'RTL'

export const APP_TITLE = 'RTL League'

export const APP_TAGLINE = 'Tecmo Super Bowl'

export const LOGO_SRC = '/rtl-logo.png'

/** Conference display metadata; red is the AFC, blue the NFC, per the logo. */
export const CONFERENCES = [
  { key: 'AFC', label: 'AFC', className: 'afc' },
  { key: 'NFC', label: 'NFC', className: 'nfc' },
] as const
